<template>
  <GenericInfo api-endpoint="permission" :type="type" @add="addsave" @save="addsave">
    <template v-slot:title>
      <h1 v-if="type === 2">{{ $t('userInformation') }}</h1>
      <h1 v-else-if="type === 1">{{ $t('editUser') }}</h1>
      <h1 v-else>{{ $t('addUser') }}</h1>
    </template>
    <template v-slot:info>
      <div class="input-group-add">
        <label for="nickname" class="label-add">{{ $t('nickname') }}:</label>
        <input
          type="text"
          id="name"
          name="name"
          placeholder="name"
          class="input-add"
          v-model="inputNameValue"
          @input="validateNameValue"
          :disabled="type === 2"
        />
      </div>
      <p v-if="errorNameMessage" class="err-msg">{{ errorNameMessage }}</p>
      <div class="input-group-add">
        <label for="username" class="label-add">{{ $t('username') }}:</label>
        <input
          type="text"
          id="username"
          name="username"
          placeholder="Username"
          class="input-add"
          :disabled="type === 2"
          v-model="inputUsernameValue"
          @input="validateUserNameValue"
        />
      </div>
      <p v-if="errorUsernameMessage" class="err-msg">{{ errorUsernameMessage }}</p>
      <div class="input-group-add" v-if="type !== 2">
        <label for="password" class="label-add">{{ $t('password') }}:</label>
        <input
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          class="input-add"
          v-model="inputPasswordValue"
          @input="validatePasswordValue"
        />
      </div>
      <p v-if="errorPasswordMessage" class="err-msg">{{ errorPasswordMessage }}</p>
      <div class="input-group-add" v-if="type !== 2">
        <label for="passwordConfirm" class="label-add">{{ $t('passwordAuthentication') }}:</label>
        <input
          type="password"
          id="passwordConfrim"
          name="passwordConfrim"
          placeholder="Password Confirm"
          class="input-add"
          v-model="inputPasswordConfirmValue"
          @input="validatePassworConfirmdValue"
        />
      </div>
      <p v-if="errorPasswordConfirmMessage" class="err-msg">{{ errorPasswordConfirmMessage }}</p>
      <div class="input-group-add">
        <label for="permission" class="label-add">{{ $t('permission') }}:</label>
        <DropdownSelect
          :id="'permission'"
          :options="permissions"
          :disabled="type === 2"
          v-model="permission"
        />
      </div>
      <div class="input-group-add">
        <label for="freeze" class="label-add">{{ $t('status') }}:</label>
        <DropdownSelect
          :id="'freeze'"
          :options="dropdownFreezeOptions"
          :disabled="type === 2"
          v-model="freeze"
        />
      </div>
    </template>
  </GenericInfo>
</template>

<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ref, onMounted, inject } from 'vue';
import Swal from 'sweetalert2';
import {
  validateCString, validateString, validatePassword,
} from '../utils/stringValid';
import {
  fetchData, fetchList, insertData, updateData,
} from '../utils/api';
import GenericInfo from '../generic/GenericInfo.vue';
import DropdownSelect from '../DropdownSelect.vue';
import { getPermission } from '../../User';

export default {
  components: {
    GenericInfo,
    DropdownSelect,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const page = ref('user');
    const btnLabel = ref(t('add'));
    const apiBaseUrl = inject('apiBaseUrl');
    const id = ref(0);
    const inputNameValue = ref('');
    const inputUsernameValue = ref('');
    const inputPasswordValue = ref('');
    const inputPasswordConfirmValue = ref('');
    const permission = ref(3);
    const freeze = ref(0);
    const route = useRoute();
    const permissions = ref([]);
    fetchList(t, `${apiBaseUrl}/list/permission`).then((response) => {
      permissions.value = response.data.result
        .filter((item) => item.id !== 1)
        .map((item) => ({
          label: item.name,
          value: item.id,
        }));
    });
    if (props.type !== 0) {
      onMounted(async () => {
        id.value = route.params.id;
        fetchData(t, `${apiBaseUrl}/info/${page.value}`, id.value).then((response) => {
          if (response.data) {
            inputNameValue.value = response.data.result.nickname;
            inputUsernameValue.value = response.data.result.username;
            permission.value = response.data.result.permission;
            freeze.value = response.data.result.freeze;
          }
        });
      });
    }
    return {
      t,
      page,
      btnLabel,
      apiBaseUrl,
      id,
      inputNameValue,
      inputUsernameValue,
      inputPasswordValue,
      inputPasswordConfirmValue,
      permission,
      permissions,
      freeze,
    };
  },
  data() {
    return {
      errorNameMessage: '',
      errorUsernameMessage: '',
      errorPasswordMessage: '',
      errorPasswordConfirmMessage: '',
      title: this.$t('confirmAdd'),
      dropdownFreezeOptions: [
        { label: this.$t('normal'), value: 0 },
        { label: this.$t('frozen'), value: 1 },
      ],
    };
  },
  methods: {
    getPermission,
    validateNameValue() {
      if (validateCString(this.inputNameValue, 2, 12)) {
        this.errorNameMessage = '';
        return true;
      }
      this.errorNameMessage = this.$t('incorrectFormat');
      return false;
    },
    validateUserNameValue() {
      if (validateString(this.inputUsernameValue, 8, 24)) {
        this.errorUsernameMessage = '';
        return true;
      }
      this.errorUsernameMessage = this.$t('incorrectFormat');
      return false;
    },
    validatePasswordValue() {
      if (this.inputPasswordValue.length === 0) {
        this.errorPasswordMessage = '';
        return true;
      }
      if (validatePassword(this.inputPasswordValue)) {
        this.errorPasswordMessage = '';
        return true;
      }
      this.errorPasswordMessage = this.$t('incorrectFormat');
      return false;
    },
    validatePassworConfirmdValue() {
      if (this.inputPasswordValue.length === 0) {
        this.errorPasswordConfirmMessage = '';
        return true;
      }
      if (this.inputPasswordValue === this.inputPasswordConfirmValue) {
        this.errorPasswordConfirmMessage = '';
        return true;
      }
      this.errorPasswordConfirmMessage = this.$t('passwordMismatch');
      return false;
    },
    validateAllInputfield() {
      let check = 0;
      if (this.type !== 0) {
        this.title = this.$t('confirmSave');
      }
      if (!this.validateNameValue()) {
        console.log('1');
        check += 1;
      }
      if (!this.validateUserNameValue()) {
        console.log('2');
        check += 1;
      }
      if (!this.validatePasswordValue()) {
        console.log('3');
        check += 1;
      }
      if (!this.validatePassworConfirmdValue()) {
        console.log('4');
        check += 1;
      }
      return check;
    },
    addsave() {
      if (this.validateAllInputfield() > 0) {
        Swal.fire({
          title: this.$t('checkFormatError'),
          icon: 'error',
        });
        return;
      }
      Swal.fire({
        icon: 'warning',
        title: this.title,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.type === 1) {
            let data = '';
            if (this.inputPasswordValue.length > 0) {
              data = JSON.stringify({
                id: this.id,
                username: this.inputUsernameValue,
                nickname: this.inputNameValue,
                permission: this.permission,
                password: this.inputPasswordValue,
                freeze: this.freeze,
              });
            } else {
              data = JSON.stringify({
                id: this.id,
                username: this.inputUsernameValue,
                nickname: this.inputNameValue,
                permission: this.permission,
                freeze: this.freeze,
              });
            }
            updateData(this.t, `${this.apiBaseUrl}/edit/${this.page}`, data, this.$router, '/user');
          } else {
            const data = JSON.stringify({
              username: this.inputUsernameValue,
              nickname: this.inputNameValue,
              permission: this.permission,
              password: this.inputPasswordValue,
              freeze: this.freeze,
            });
            insertData(this.t, `${this.apiBaseUrl}/new/${this.page}`, data, this.$router, '/user');
          }
        }
      });
    },
  },
};
</script>
<style></style>
